module.exports = __webpack_public_path__ + "img/dental-hygienist.189954b0.jpg";